import { render, staticRenderFns } from "./FormDisplayOrderMenu.vue?vue&type=template&id=052b7dfc&scoped=true"
import script from "./FormDisplayOrderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDisplayOrderMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormDisplayOrderMenu.vue?vue&type=style&index=0&id=052b7dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b7dfc",
  null
  
)

export default component.exports